import {
  ClientDataSearchRequest,
  ClientDataSearchResponse,
  CustomRequestHeaderUnion,
} from '@blk/aw-bff-typescript-models';
import { AxiosRequestConfig } from 'axios';
import { generateRequestConfig } from '../../utils/CloakDataUtils';
import { awSensitiveDataApi } from './Base';

export interface PostCloakDataSearchParams {
  pkg?: string;
}

export function postCloakDataSearch(
  params: PostCloakDataSearchParams,
  payload: ClientDataSearchRequest,
  url: string,
  customHeaders: CustomRequestHeaderUnion[]
) {
  const config: AxiosRequestConfig = generateRequestConfig(params, customHeaders);
  // It could return a different shape. Refers to AWM-23897
  return awSensitiveDataApi.post<ClientDataSearchResponse>(url, payload, config);
}
